import { hasChildren } from "shared/lib/hasChildren"

type Node = { id: string; children?: Node[] | null | undefined }

export function getDepth(node: Node): number {
  if (!hasChildren(node)) {
    return 1
  }
  return Math.max(...(node.children || []).map(getDepth), 1) + 1
}
